import { Fragment, useContext, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CogIcon, DownloadIcon, XIcon } from '@heroicons/react/outline';
import { UserSlideOverContext } from 'context/UserSlideOverContext';
import { Backend } from 'api/ApiConsumer';
import { API_ROUTES } from 'routes/api';

const fileDownload = require('js-file-download');

export default function UserSlideDetail() {
  const { userDetails, setUserDetails } = useContext(UserSlideOverContext);
  const [downloadingAcitivityFile, setDownloadingAcitivityFile] =
    useState(false);

  const onDataDownload = () => {
    setDownloadingAcitivityFile(true);
    Backend.get(API_ROUTES.USERS.DOWNLOAD_ACTIVITIES(userDetails.id))
      .then((res) => {
        fileDownload(
          res.data,
          `${userDetails.first_name}-${userDetails.last_name}-activities.csv`,
        );
        setDownloadingAcitivityFile(false);
      })
      .catch(() => setDownloadingAcitivityFile(false));
  };

  return (
    <Transition.Root show={userDetails?.open ?? false} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50"
        onClose={() => setUserDetails({ open: false })}
      >
        <div className="absolute inset-0">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="pointer-events-auto relative w-96">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-500"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-500"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                    <button
                      type="button"
                      className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      onClick={() => setUserDetails({ open: false })}
                    >
                      <span className="sr-only">Close panel</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </Transition.Child>
                <div className="h-full overflow-y-auto bg-white p-8">
                  {userDetails?.activities?.length ? (
                    <h3 className="font-semibold text-xl mb-3">Audit Trail</h3>
                  ) : (
                    <p className="text-gray-500 py-3">
                      No data available for user.
                    </p>
                  )}
                  {userDetails?.activities?.map((item) => {
                    const d = new Date(item.created);
                    return (
                      <p key={item.id} className="text-gray-500 py-3">
                        {d.toDateString() + ' ' + d.toLocaleTimeString()}
                        {'  '}
                        <span className="text-gray-700">{item.activity}</span>
                      </p>
                    );
                  })}

                  {userDetails?.activities?.length ? (
                    <div className="flex items-center w-full justify-center">
                      <button
                        onClick={onDataDownload}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
                      >
                        {downloadingAcitivityFile ? (
                          <CogIcon className="animate-spin h-5 w-5 content-center text-center mx-auto" />
                        ) : (
                          <DownloadIcon className="h-5 w-5 content-center text-center mx-auto" />
                        )}
                        <span className="m-1 inline-block">
                          Download Activity Data
                        </span>
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
